import { useRecentProducts } from './useRecentProducts'

export default useRecentProducts
